export const EVENT_NAME_INTERACTION = 'object-interacted';
export const EVENT_NAME_HELP_TEXT_EXPAND = 'tooltip-expanded';
export const EVENT_NAME_HELP_TEXT_PRESS = 'tooltip_pressed';
export const EVENT_NAME_TEXT_INPUT_INTERACTION =
  'job-ad-details-item-interacted';
export const EVENT_NAME_ALERT_VIEWED = 'alert_viewed';
export const EVENT_NAME_CTA_PRESSED = 'cta_pressed';

export const JOB_OBJECT_PRESSED = 'job_object_pressed';

export const TEALIUM_PAGE_CREATE = 'create';
export const TEALIUM_PAGE_CLASSIFY = 'classify';
export const TEALIUM_PAGE_CONCIERGE = 'concierge';
export const TEALIUM_PAGE_GUARANTEED_HIRE = 'guaranteed-hire';
export const TEALIUM_PAGE_PREMIUM_PLUS = 'premium-plus';
export const TEALIUM_PAGE_MULTI_LOCATION = 'multi-location';
export const TEALIUM_PAGE_PAY_AND_POST = 'checkout';
export const TEALIUM_PAGE_ROLE_REQS = 'shortlist';
export const TEALIUM_PAGE_SELECT_AD = 'select-ad';
export const TEALIUM_PAGE_SUCCESS = 'checkout-complete';
export const TEALIUM_PAGE_WRITE = 'write';

export const TEALIUM_PAGE_EDIT = 'job edit ad';
export const TEALIUM_PAGE_EDIT_PAY_AND_POST = 'pay and post';

export const TEALIUM_PAGE_REFRESH = 'job refresh ad';
export const TEALIUM_PAGE_REFRESH_ERROR = 'job refresh ad error';

export const EVENT_NAME_JOB_AD_POSTED_WITH_RR = 'job-ad-posted-with-rr';

export const EVENT_NAME_VIEW_CLASSIFY = 'ecaja-classify-viewed';
export const EVENT_NAME_VIEW_CONCIERGE = 'ecaja-concierge-viewed';
export const EVENT_NAME_VIEW_GUARANTEED_HIRE = 'ecaja-guaranteed-hire-viewed';
export const EVENT_NAME_VIEW_MULTI_LOCATION = 'ecaja-multi-location-viewed';
export const EVENT_NAME_VIEW_PAY_AND_POST = 'ecaja-checkout-viewed';
export const EVENT_NAME_VIEW_ROLE_REQS = 'ecaja-role-req-viewed';
export const EVENT_NAME_VIEW_SELECT_AD = 'ecaja-select-ad-viewed';
export const EVENT_NAME_VIEW_SUCCESS = 'ecaja-completed-page-viewed';
export const EVENT_NAME_VIEW_WRITE = 'ecaja-write-viewed';

export const EVENT_NAME_VIEW_EDIT = 'job_edit_displayed';
export const EVENT_NAME_VIEW_EDIT_PAY_AND_POST = 'pay_and_post_displayed';

export const EVENT_NAME_VIEW_REFRESH = 'job_refresh_ad_displayed';

export const EVENT_NAME_CAJA_START = 'ecaja-start';
export const EVENT_NAME_EMAIL_UNVERIFIED = 'email-unverified';
export const EVENT_NAME_CONFIRMED_VIEWED = 'ecaja-confirmed-viewed';
export const EVENT_TYPE_TOGGLE = 'toggle_pressed';
export const EVENT_TYPE_CURRENCY_TYPE_SELECTED = 'currency_type_selected';
export const EVENT_NAME_CONTRACT_PURCHASE_VIEWED =
  'seek-contract-purchase-viewed';

export const PRODUCT_EVENTS_PURCHASE = 'purchase';
export const PRODUCT_CATEGORIES_AD = 'jobAd';
export const PRODUCT_QUANTITIES_JOB_AD_QUANTITY = '1';
export const PRIVATE_AD = 'private ad';
export const HIDE_SALARY = 'hide salary';
export const LINK_NAME_RESPONSIBILITIES =
  'ecaja-job-ad-details-tasks-responsibilities-interacted';
export const OBJECT_INTERACTION_RESPONSIBILITIES = 'tasks-responsibilities';
export const LINK_NAME_QUALIFICATIONS =
  'ecaja-job-ad-details-qualifications-experiences-interacted';
export const OBJECT_INTERACTION_QUALIFICATIONS = 'qualifications-experience';
export const LINK_NAME_BENEFITS = 'ecaja-job-ad-details-benefits-interacted';
export const OBJECT_INTERACTION_BENEFITS = 'benefits';

export const OBJECT_INTERACTED = 'object-interacted';
export const PAY_BY_CREDIT_CARD_LINK = 'ecaja-pay-by-credit-card';
export const PAY_BY_CREDIT_CARD = 'pay-by-credit-card';
export const PAY_BY_INVOICE_LINK = 'ecaja-pay-by-invoice';
export const PAY_BY_INVOICE = 'pay-by-invoice';
